export function logAppLoadSection(section: string, message?: string): void {

    const dt = new Date();
    const formattedTime = dt.toISOString().replace('T', ' ').replace('Z', '');
    console.log(`[${formattedTime}] APP_LOADER => [${section}]${ message ? ` ${message}` : ''}`);
}